import { Container } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import type { WithMetadata } from "../../pages";
import { Addresses } from "./Addresses";
import { FooterLinks } from "./FooterLinks";
import { SmallPrint } from "./SmallPrint";
import { Support } from "./Support";
import type { FooterProps } from "./types";
import "./Footer.css";

export const Footer = (props: WithMetadata<FooterProps>) => {
  const {
    className,
    phoneNumber,
    openingHours,
    addresses,
    links,
    smallPrint,
    componentName,
    ...otherProps
  } = props;
  const classes = classNames("mobius", "mobius-footer", className);
  const { variant } = otherProps;

  return (
    <footer
      {...otherProps}
      {...(componentName ? { "data-component": componentName } : {})}
      {...(variant ? { "data-variant": variant } : {})}
      className={classes}
    >
      <Container size="sm" className="mobius-footer__content">
        <Support phoneNumber={phoneNumber} openingHours={openingHours} />
        <Addresses addresses={addresses} />
        <FooterLinks links={links} />
        <SmallPrint text={smallPrint} />
      </Container>
    </footer>
  );
};
